// extracted by mini-css-extract-plugin
module.exports = {"img":"SplashBackground_img__4L3Rg","visible":"SplashBackground_visible__gjWWR","open":"SplashBackground_open__h9YQh"};